module.exports = __webpack_public_path__ + "img/14.44363f42.jpg";